import { render, staticRenderFns } from "./standardBill.vue?vue&type=template&id=19f9d5b0&scoped=true"
import script from "./standardBill.vue?vue&type=script&lang=js"
export * from "./standardBill.vue?vue&type=script&lang=js"
import style0 from "./standardBill.vue?vue&type=style&index=0&id=19f9d5b0&prod&scoped=scoped&lang=css"
import style1 from "./standardBill.vue?vue&type=style&index=1&id=19f9d5b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f9d5b0",
  null
  
)

/* custom blocks */
import block0 from "./standardBill.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports